import React from 'react';
import i18n from '../../../i18n/i18n';

import { PublicRoute } from '../../../utils/routes';
import LazyImage from '../../../components/LazyImage';

import arrowIcon from "../../../images/bulkListing/right-arrow-icon.png";

const EnquiryBanner = () => {
  return (
    <div className="w-full bg-[url('./images/bulkListing/enquiry-background.png')] bg-[length:100%] bg-center bg-cover bg-no-repeat p-[25px] md:py-[30px] md:px-[70px] lg:py-[30px] lg:px-[100px] xl:px-[200px] 2xl:px-[300px]">
      <div className="flex flex-col items-center m-[30px] md:m-[50px]">
        <div className="text-[15px] text-white font-bold text-center md:text-[22px]">{i18n.t("bulkListing.enquiryBanner.title")}</div>
        <div className="flex mt-[20px]">
          <a href={PublicRoute.BulkListingEnquiry}>
            <div className="bg-gradient-to-r from-[#D93C61] to-[#E5666B] w-[280px] h-[60px] flex flex-row items-center m-[10px] pl-[15px] pr-[20px] py-[10px] border-[0.5px] border-white rounded-[10px] md:w-[450px] md:py-[5px] lg:h-[80px]">
              <div className="mx-[10px] text-[12px] text-white md:text-[16px]">{i18n.t("bulkListing.enquiryBanner.collabEnquiry")}</div>
              <LazyImage className="w-[18px] ml-auto object-contain md:w-[25px]" src={arrowIcon} alt="arrow-icon" />
            </div>
          </a>
        </div>
      </div>
    </div>
  )
}

export default EnquiryBanner;